import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { PageNames } from 'src/app/configs/page-names.enum';
import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  GetEnumValuesDto,
  GetPrivateNumberBuyRequestsWithPaginationDto,
  PaginatedListOfGetPrivateNumberBuyRequestsWithPaginationDto,
  PrivateNumberBuyRequestStatus,
} from 'src/app/core/api/models';
import { PrivateNumberBuyRequestService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { MenuBtnComponent } from 'src/app/shared/global/menu-btn/menu-btn.component';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { PrivateNumberUploadDocumentsModule } from '../private-number-upload-documents-form/private-number-upload-documents-form.module';
import { LocalPrivateNumberPriceService } from '../shared/local-private-number-price.service';
import { PrivateNumberBuyRequestStatusDirective } from '../shared/private-number-buy-request-status.directive';
import { FormPageConfig } from './../../../core/models/form-page-config.model';
import { RefreshMenuService } from './../../../core/services/refresh-menu.service';

@Component({
  selector: 'app-private-number-buy-requests',
  imports: [
    BaseIndexModule,
    PrivateNumberBuyRequestStatusDirective,
    MenuBtnComponent,
    PrivateNumberUploadDocumentsModule,
  ],
  templateUrl: './private-number-buy-requests.component.html',
})
export class PrivateNumberBuyRequestsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region properties
  pageName = PageNames.privateNumberBuyRequests;
  protected currentService = inject(PrivateNumberBuyRequestService);
  paginationApiMethodName: string =
    this.currentService
      .privateNumberBuyRequestGetPrivateNumberBuyRequestsWithPagination.name;
  auditApiMethodName: string =
    this.currentService
      .privateNumberBuyRequestGetPrivateNumberPricesAuditWithPagination.name;
  title = 'pages.privateNumberBuyRequests.title';
  modelWithPagination$: Observable<PaginatedListOfGetPrivateNumberBuyRequestsWithPaginationDto>;
  items$: Observable<Array<GetPrivateNumberBuyRequestsWithPaginationDto>>;
  formPageConfig: FormPageConfig<any> = {};
  PrivateNumberBuyRequestStatusEnumValues: GetEnumValuesDto[] = [];
  requestId: number;
  get PrivateNumberBuyRequestStatus() {
    return PrivateNumberBuyRequestStatus;
  }
  showUploadDocuments: boolean = false;
  //#endregion

  constructor(public refreshMenuService: RefreshMenuService) {
    super();
  }
  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showAuditBtn = false;

      if (LocalPrivateNumberPriceService.privateNumberBuyRequestId) {
        this.onShowUploadDocuments(
          LocalPrivateNumberPriceService.privateNumberBuyRequestId
        );
        LocalPrivateNumberPriceService.privateNumberBuyRequestId = null;
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.privateNumberPrice
      );
    }
  }

  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Documents_key)
        this.onShowChildPage({
          values: [...(value as string)?.split('_')],
          setUrl: false,
          queryStringKey: key,
          class: this,
          showPagePropKey: this.componentProperties.showUploadDocuments,
          selectedPropKey: [
            {
              keyName: this.componentProperties.requestId,
              keyType: typeof this.requestId,
            },
          ],
        });
    }
  }

  getEnumsValues() {
    this.getEnumValuesApi('PrivateNumberBuyRequestStatus')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(
        (values) => (this.PrivateNumberBuyRequestStatusEnumValues = values)
      );
  }

  configTableColumns(): void {
    this.tableColumns = [
      {
        title: this.localizer.number,
        name: 'number',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: this.localizer.organization,
        name: 'OrganizationName',
        hasSearch: true,
      },
      {
        title: `${this.tableVocabs}payAmount`,
        name: 'payAmount',
        hasSearch: true,
        needCurrency: true,
        type: 'number',
      },
      {
        title: `${this.tableVocabs}isService`,
        name: 'isService',
        type: 'boolean',
        hasSearch: true,
      },
      {
        title: this.localizer.status,
        name: 'PrivateNumberBuyRequestStatus',
        hasSearch: true,
        type: 'enum',
        enumName: 'PrivateNumberBuyRequestStatus',
      },
      {
        title: `${this.tableVocabs}rejectionDescription`,
        name: 'rejectionDescription',
        hasSearch: true,
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region api

  //Get ById
  baseGetByIdApi(id: number): void {
    // this.unSubs();
    // this.pageConfig.loading = true;
    // this.formPageConfig.editId = id;
    // this.currentService
    //   .privateNumberPriceUpdateGet({
    //     Id: id
    //   })
    //   .pipe(this.basePipeOperators())
    //   .subscribe(this.baseGetByIdObserver);
  }

  //Delete
  baseDeleteApi(id: number) {
    this.unSubs();

    this.pageConfig.loading = true;
    this.lastSelectedItemId = id;

    this.currentService
      .privateNumberBuyRequestDelete({
        body: { id: id },
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseDeleteObserver);
  }

  //#endregion

  onShowUploadDocuments(id: number, setUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Documents_key +
          '=' +
          id
      );
    }
    this.requestId = id;
    this.showUploadDocuments = true;
  }
}
